module.exports = __webpack_public_path__ + "img/552c858.png";